// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/page_assets/sass/sad-page.scss
// module id = 21
// module chunks = 0